export default __webpack_public_path__ + "static/media/wheelGamenew.bf16a049.jpg";